module.exports = __webpack_public_path__ + "static/media/1656996409linkedin-symbol.57367cd5.png";